import { render, staticRenderFns } from "./BottomView.vue?vue&type=template&id=e16a2938&scoped=true"
import script from "./BottomView.vue?vue&type=script&lang=js"
export * from "./BottomView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16a2938",
  null
  
)

export default component.exports